var map = {
	"./sc1.png": 146,
	"./sc2.png": 319,
	"./sc3.png": 421,
	"./sc4.png": 292,
	"./sc5.png": 354,
	"./sc6.png": 869,
	"./sc7.png": 215,
	"./sc8.png": 798
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 613;